import React ,{  useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Footer from "../Components/Footer/footer";
import LandingHero from "../Components/Landing/hero";
import AboutKryzen from "../Components/Landing/about";
import WhyChooseKryzen from "../Components/Landing/why";
import NewsletterSection from "../Components/Landing/newsletter";
import LatestPosts from "../Blog/latest_posts";
import EventCards from "../Blog/events_card";

 
export default function CalenderPage() {

 

    useEffect(() => {
  
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Kryzen Info",
        alternateName: "Kryzen Biotech",
        parentOrganization: {
          "@type": "Corporation",
          name: "Kryzen Biotech Pvt. Ltd.",
          url: "https://kryzen.com",
        },
        url: "https://kryzen.info",
        logo: "https://kryzen.com/og-image.jpg",
        description:
          "Kryzen Info is the media & knowledge division of Kryzen Biotech, providing hydroponics trends, innovations, subsidies, farm setup guidelines & modern farming education.",
        sameAs: [
          "https://facebook.com/kryzenbiotech",
          "https://www.instagram.com/kryzen_biotech",
          "https://in.linkedin.com/company/kryzen",
          "https://www.youtube.com/@kryzen",
        ],
      });
  
      document.head.appendChild(script);
  
      return () => {
        document.head.removeChild(script);
      };
    }, [])
  
   
  

  return (
    <>
      <Helmet>
         
   <title>India’s Hydroponics & AgriTech Events Calendar – Stay Ahead of the Curve</title>

  <meta name="description" content="Kryzen Info is the media & knowledge division of Kryzen Biotech, providing hydroponics trends, innovations, subsidies, modern farming insights, and agri-tech updates across India." />
  <meta name="keywords" content="hydroponics india, modern farming, agritech india, kryzen biotech, hydroponic trends, smart farming india, hydroponic subsidies, greenhouse farming india, hydroponic webinar" />
  <meta name="robots" content="index, follow" />

        
   <link rel="canonical" href="https://kryzen.info/" />

  <meta property="og:site_name" content="Kryzen Info" />
  <meta property="og:title" content="Kryzen Info - India's Hydroponics & Smart Farming Knowledge Hub" />
  <meta property="og:description" content="Daily hydroponics trends, AgriTech innovations, subsidies, greenhouse education & farm automation insights." />
  <meta property="og:image" content="https://kryzen.com/og-image.jpg" />
  <meta property="og:url" content="https://kryzen.info" />
  <meta property="og:type" content="website" />

        {/* Twitter */}

  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Kryzen Info - Hydroponics News & Innovations" />
  <meta name="twitter:description" content="India’s fastest-growing modern farming knowledge Hub." />
  <meta name="twitter:image" content="https://res.cloudinary.com/dfhuelkzw/image/upload/v1763957144/kryzen_info-logo_iudzc9.png" />
 
      </Helmet>

      <div className="page-wrapper container">
        <LandingHero 
           title = "India’s Hydroponics & AgriTech Events Calendar – Stay Ahead of the Curve"
           subtitle= "Discover all major hydroponics events happening across India—training sessions, technical workshops, AgriTech expos, research updates, greenhouse innovation conferences, and Kryzen Biotech’s exclusive events. Whether you’re a beginner, a commercial farmer, or an investor, our event calendar ensures you never miss an opportunity to learn and gro"
           buttonText = "🌿 Join Newsletter"
           buttonLink = "#newsletter"
           background = "bg-light"
        />
                <div className="">
        <div className="row ">
          <div className="col-12 ">
            {/* <ServicesSection /> */}
            <h2
  className="mt-0  mb-4 fs-3 fs-md-2 fs-lg-1 fw-bold text-white p-3 rounded-3 text-center reveal bg-green"
  
>
  Upcoming Hydroponic Events
</h2>

            <EventCards />
          </div>

          {/* <div className="col-4  sidebar px-4" >
            <div className="d-flex justify-content-space-between ">
                 <div className="">
                    <img
                    width={150}
                    height={150}
                    src= "https://res.cloudinary.com/dfhuelkzw/image/upload/v1763963968/Farm_Training_1_zhixdv.gif"/>
    
                 </div>
                 <div className="ms-2" >
                 <img
                    width={150}
                    height={150}
                    src= "https://res.cloudinary.com/dfhuelkzw/image/upload/v1764237278/Farm_Training_2_kfjosj.png"/>    
                 </div>
                 <div className="ms-2">
                    <img
                    width={150}
                    height={150}
                    src= "https://res.cloudinary.com/dfhuelkzw/image/upload/v1764237422/Farm_Training_2_zykuon.gif"/>    
                 </div>
            </div>
            <div>
           <h2 className="mt-4 fs-1">Trending Articles</h2>
      
      <RandomPosts /> 
           </div>
            <div>
               <KryzenSocialCard />
            </div>
          <div>

            <SharkTankKryzenVideo />
          </div>

          <div>
<GalleryCarouselCard />

          </div>
           
            
           
           <div className="mt-2">
           <AgriSubsidyCard /> 

           </div>
           <div>
             <HydroponicWebinarCard /> 
           </div>
           <div>
            <FarmSetupCard />
           </div>
          </div> */}
        </div>
        </div>
        <hr  className="border border-1 border-dark"/>
        <LatestPosts /> 
        <AboutKryzen />
        <WhyChooseKryzen />
        <NewsletterSection />
        <Footer />
      </div>
    </>
  );
}
